import { __assign } from "tslib";
import { observer, Provider } from 'mobx-react';
import * as React from 'react';
import { CheckAddress } from './containers/check-address';
import { CheckCustomer } from './containers/check-customer';
import Signup from './containers/signup/';
import { NewSaleFailure } from './containers/signup/components/NewSaleFailure';
import { RootStore } from './stores';
export var AnexSignUp = observer(function (props) {
    var stores = React.useState(new RootStore(props))[0];
    React.useEffect(function () {
        getQueryString();
        stores.checkAddressStore.loadLevelTypes();
        stores.checkAddressStore.loadStates();
        stores.checkAddressStore.loadStreetTypes();
        stores.checkAddressStore.loadUnitTypes();
        stores.hardwareStore.loadHardware();
        stores.planStore.loadPlans();
        stores.planStore.loadVoipPlans();
        return function () {
            stores.checkAddressStore.resetCheckForm();
            stores.saleStore.reset();
            stores.summaryStore.resetSummary();
            if (typeof 'window' !== 'undefined') {
                try {
                    window.scroll({
                        top: 0,
                        left: 0,
                        behavior: 'smooth',
                    });
                }
                catch (error) {
                    window.scrollTo(0, 0);
                }
            }
        };
    }, []);
    function getQueryString() {
        var queryString = window.location.search;
        var params = new URLSearchParams(queryString);
        var code = params.get('pl');
        if (code) {
            stores.planStore.setPlanCode(code);
        }
    }
    return (React.createElement(Provider, __assign({}, stores), {
        0: React.createElement(CheckAddress, null),
        1: React.createElement(CheckCustomer, null),
        2: React.createElement(Signup, null),
        3: React.createElement(NewSaleFailure, null),
    }[stores.appStore.currentState]));
});
//# sourceMappingURL=index.js.map